import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex)

import Coordinates from "@/store/modules/Coordinates";
import Filters from "@/store/modules/Filters";
import Interface from "@/store/modules/Interface";
import Routes from "@/store/modules/Routes";
import Settings from "@/store/modules/Settings";

import actions from "@/store/actions";

const store = new Vuex.Store({

  modules: {
    Coordinates,
    Filters,
    Interface,
    Routes,
    Settings
  },

  actions

})

export default store
